<template>
    <div class="pm-register">
        <div class="reg-main-title">
            服装版师<span>专属入驻通道</span>
        </div>
        <div class="reg-sub-desc">
            入驻成为平台认证版师,解锁更多服装订单与行业资源,让你的制版技术更有价值
        </div>
        <div class="reg-btn" @click="onApply">申请入驻</div>
        <div v-if="status>=0" class="apply-progress" @click="onCheck">查看申请进度</div>
    </div>
</template>
<script>
import { patternMakerInfo } from '@/api/index';
import { mapState } from 'vuex';
export default{
    data(){
        return{
            status:-1
        }
    },
    computed:{
        ...mapState({
            userInfo:state=>state.userInfo,
            is_login:state=>state.is_login
        })
    },
    mounted(){
      if(this.is_login){
        this.getCheckInfo();
      }
    },
    methods:{
        async getCheckInfo(){
            try{
                const {code,data} = await patternMakerInfo();
                console.log('data',data);
                this.status = data.status;
                if(code>0){
                    this.status = -1;
                    return false;
                }
                if(data.status && data.status == 1){
                    console.log('apply-status',data.status)
                    this.$layer.msg('申请已通过');
                    return true;
                }
                return false;
            }catch(e){
                console.log('err',e);
            }
        },
        async onCheck(){
            const check = await this.getCheckInfo();
            console.log('check-status',!check,check);
            if(!check){
                this.$router.push({name:'PMResult',query:{type:"checking"}})
            }
        },
        async onApply(){
            if(!this.userInfo.id){
                this.$layer.msg('请先注册成为平台用户或登录再操作');
                this.$router.push({name:"Login",query:{back_name:'PMRegister',type:'wechat'}});
                return;
            }
            const check = await this.getCheckInfo();
            if(!check){
                this.$router.push({
                    name:"PMRegisterForm"
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.pm-register{
    width:100%;
    height:calc(100vh - 60px - 50px);
    background:url('../../assets/images/patternMaker/bg-patterm-maker.png') no-repeat;
    background-size:cover;
    background-position:center;
    display:flex;
    // justify-content:center;
    align-items:center;
    flex-direction:column;
    .reg-main-title{
        color:#000;
        font-size:58px;
        font-weight:bold;
        display:flex;
        align-items:center;
        margin-top:234px;
        span{
            color:#1b7bf8;
        }
    }
    .reg-sub-desc{
        margin-top:30px;
        color:#000;
        font-size:24px;
    }
    .reg-btn{
        width:320px;
        height:56px;
        line-height:56px;
        border-radius:16px;
        color:#fff;
        background:#ff5967;
        cursor:pointer;
        margin-top:77px;
        text-align:center;
        font-size:18px;
        font-weight:bold;
    }
    .apply-progress{
        margin-top:24px;
        color:#0d99ff;
        cursor:pointer;
        text-decoration: underline;
    }
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .pm-register {
    .reg-main-title {
      font-size: 42px; /* 缩小标题字体 */
      margin-top: 180px; /* 减少上边距 */
      
      span {
        font-size: 42px; /* 保持一致 */
      }
    }
    
    .reg-sub-desc {
      font-size: 20px; /* 缩小副标题字体 */
      margin-top: 24px; /* 调整间距 */
    }
    
    .reg-btn {
      width: 280px; /* 调整按钮宽度 */
      height: 50px; /* 调整按钮高度 */
      line-height: 50px;
      font-size: 16px; /* 调整按钮字体 */
      margin-top: 60px; /* 调整按钮上边距 */
    }
    
    .apply-progress {
      font-size: 14px; /* 调整链接字体 */
      margin-top: 20px; /* 调整间距 */
    }
  }
}
@media (max-width: 1279px) {
  .pm-register {
    .reg-main-title {
      font-size: 36px; /* 进一步缩小标题字体 */
      margin-top: 120px; /* 显著减少上边距 */
      
      span {
        font-size: 36px; /* 保持一致 */
      }
    }
    
    .reg-sub-desc {
      font-size: 18px; /* 进一步缩小副标题字体 */
      margin-top: 20px; /* 调整间距 */
    }
    
    .reg-btn {
      width: 240px; /* 进一步调整按钮宽度 */
      height: 46px; /* 进一步调整按钮高度 */
      line-height: 46px;
      font-size: 15px; /* 进一步调整按钮字体 */
      margin-top: 45px; /* 调整按钮上边距 */
    }
    
    .apply-progress {
      font-size: 13px; /* 进一步调整链接字体 */
      margin-top: 18px; /* 调整间距 */
    }
  }
}
</style>